module.exports = __webpack_public_path__ + "static/media/watopedia.2398725f.png";